<template>
  <div>
    <div
      :class="[
        `form-checkbox`,
        error && `form-checkbox--error`
      ]"
      @click.prevent="onClick()"
    >
      <input
        :id="`singleCheckbox-${label}`"
        type="checkbox"
        :name="`singleCheckbox-${label}`"
        :class="[`form-checkbox__field`, checked && `form-radio__field--checked`]"
        :checked="checked"
        :disabled="disabled"
      />
      <label
        :class="[
          `form-checkbox__label`,
          hover && `hover`,
          focus && `focus active`,
        ]"
        :for="`singleCheckbox-${label}`"
      >{{ label }}</label>
    </div>
    <div v-if="helpMessage" class="form-help form-help--checkbox">
      {{ helpMessage }}
      <slot name="helpLink"></slot>
    </div>
    <p
      v-if="errorMessage"
      class="form-label form-label--error form-label--error--active"
    >{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "CheckboxStandard",
  props: {
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    helpMessage: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    hover: {
      type: Boolean,
      required: true,
    },
    focus: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick", !this.checked);
    },
  },
};
</script>